import { DownloadIcon } from "@radix-ui/react-icons";
import { Loader2 } from "lucide-react";
import { useSupplyChainLotExport } from "../../hooks/useSupplyChainLotExport";
import { Button } from "@/components/ui/button";
import { type BenchmarkFilters } from "@/routes/(authed)/_layout.benchmarks";
import { selectActiveJobs } from "@/store/asyncJobs";
import { useAppSelector } from "@/store/hooks";

const MAX_CONCURRENT_EXPORTS = 3;

interface ExportLotsButtonProps {
  filters: BenchmarkFilters;
}

export function ExportLotsButton({ filters }: ExportLotsButtonProps) {
  const { handleExport, loading } = useSupplyChainLotExport();

  const activeJobs = useAppSelector(selectActiveJobs);
  const activeLotExports = activeJobs.filter((job) => job.type === "SUPPLY_CHAIN_LOT_EXPORT");
  const hasReachedLimit = activeLotExports.length >= MAX_CONCURRENT_EXPORTS;

  const handleClick = () => {
    void handleExport(filters);
  };

  const isDisabled = loading || hasReachedLimit;

  return (
    <Button
      onClick={handleClick}
      disabled={isDisabled}
      variant="outline"
      className="gap-2"
      title={`Maximum of ${MAX_CONCURRENT_EXPORTS} concurrent exports allowed.`}
    >
      {loading ? (
        <Loader2 data-testid="loading-spinner" className="h-4 w-4 animate-spin" />
      ) : (
        <DownloadIcon data-testid="download-icon" className="h-4 w-4" />
      )}
      Export Lots {activeLotExports.length > 0 && `(${activeLotExports.length}/${MAX_CONCURRENT_EXPORTS})`}
    </Button>
  );
}
